import { type Key, createContext, useContext } from 'react';

type MovePriorityItem = (itemKey: Key, targetKey: Key) => void;

export const PriorityMoveContext = createContext<MovePriorityItem | undefined>(undefined);

export const usePriorityMove = () => useContext(PriorityMoveContext);
